var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "transaction-form pay-form-wrapper card-payment-bg" },
    [
      _c("div", { staticClass: "form-bar", attrs: { id: "#payment-form" } }, [
        _c("div", { staticClass: "no-gutters my-2" }, [
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.stripeReady,
                expression: "stripeReady"
              }
            ],
            staticClass: "payment-element-wrapper",
            attrs: { id: _vm.paymentElementId }
          }),
          _vm._v(" "),
          !_vm.stripeReady
            ? _c(
                "div",
                {
                  staticClass: "d-flex justify-center align-items",
                  staticStyle: { height: "125px" }
                },
                [
                  _c("HollowDotsSpinner", {
                    staticClass: "d-flex align-items-center",
                    attrs: {
                      "animation-duration": 1000,
                      "dot-size": 14,
                      "dots-num": 3,
                      color: "var(--stan-primary-primary-color)"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }